import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import {
  getGeneralProjects,
} from "../../../apis/actions/projects.actions";
import ComposedCard from "../../../biblio/Cards/ComposedCard";
import { getAllKorba } from "../../../apis/actions/korba.actions";

const OtherKorbasCard = () => {
  const dispatch = useDispatch<AppDispatch>();

  const korbas = useSelector((state: RootState) => state?.korbas?.korbas);
  const korbaTypes = useSelector(
    (state: RootState) => state?.korbas?.korbaTypes
  );

  const detailKorba = useSelector(
    (state: RootState) => state?.korbas?.detailsKorba
  );

  const [filteredProjects, setFilteredProjects] = useState<any[]>(korbas);

  useEffect(() => {
    dispatch(getAllKorba());
    dispatch(getGeneralProjects());
  }, [dispatch]);

  useEffect(() => {
    setFilteredProjects(
      korbas
        .filter((project: any) => project.id !== detailKorba?.id)
        .sort((a: any, b: any) => {
          return a.sequence - b.sequence;
        })
    );
  }, [korbas, detailKorba]);

  return (
    <div className="takaful--card-other-container">
      <div className="takaful--card-other-title">
        <span>حالات اخرى تحتاج دعمك</span>
      </div>

      <div className="takaful--cases-section">
        <div className="takaful--cases" style={{ marginTop: "10rem" }}>
          {filteredProjects.length > 0 &&
            filteredProjects
              .slice(0, 4)
              .map((project: any, index: number) => (
                <ComposedCard
                  key={index}
                  donation_type_ids={korbaTypes}
                  type="تفريج كرب"
                  project={project}
                  cardClass={"card-1"}
                />
              ))}
        </div>
      </div>
    </div>
  );
};

export default OtherKorbasCard;
